import React from 'react';
import ModalCard, { modalSize } from 'shared-assets/components/Modal/ModalCard';
import Grid from '@material-ui/core/Grid';
import { Box, Button } from '@kareo/design-system';
import CachedDataWarning from 'shared-assets/facesheet-ui/components/Facesheet/Error/CachedDataWarning';
import { CACHED_DATA_MESSAGE } from 'shared-assets/facesheet-ui/service/patient/types';

class UnrestrictedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <ModalCard
        open={this.props.open}
        header={
          <h4 style={{ marginTop: '11px', marginBottom: '11px' }}>
            Restricting Access to {this.props.firstName} {this.props.lastName}
          </h4>
        }
        size={modalSize.default}
        closeIcon
        cardStyle={{
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        onClose={this.props.handleClose}
        footer={
          <Grid container direction="row-reverse">
            <Grid item>
              <Button onClick={this.props.handleClose} color="vitality">
                Close
              </Button>
            </Grid>
          </Grid>
        }
      >
        <If
          condition={this.props.cachedChartAccessContext?.isCachedDataDisplayed}
        >
          <Box mb={1}>
            <CachedDataWarning
              messageType={CACHED_DATA_MESSAGE.WITH_DATE}
              lastCachedDate={
                this.props.cachedChartAccessContext?.lastCachedDate
              }
              displayBorder
            />
          </Box>
        </If>
        <span>
          You do not have access to restrict a patient’s chart. To restrict
          access, please consult:
        </span>
        <ul style={{ all: 'revert', margin: '0' }}>
          <li
            style={{
              listStyleType: 'disc',
              display: 'list-item',
            }}
          >
            Front desk or an Administrator
          </li>
        </ul>
      </ModalCard>
    );
  }
}

export default UnrestrictedModal;
